<template>
  <Loading heading="Logging in" description="Wait before we redirect you!" />
</template>

<script>
import Loading from "../components/Loading.vue";
import { hashStringToObject } from "@/utils/stringHelpers";

export default {
  watch: {
    "$route.hash": {
      async handler(hash) {
        if (!hash) return this.$router.push("login");
        const hashPayload = hashStringToObject(hash);

        if (hashPayload.error) return this.$router.push("login");

        const [, type, value] = decodeURIComponent(hashPayload.state).split(
          ";"
        );

        if (type === "INVITE") {
          this.$router.push({
            name: "setupaccount",
            query: { hash: value, oidc: hash },
          });
          return;
        }

        if (type === "REGISTER") {
          this.$router.push({
            name: "register",
            query: { oidc: hash, subscriptionTemplate: value },
          });
          return;
        }

        await this.$store
          .dispatch("AUTH/LOGIN_OIDC", hashPayload)
          .then(() => {
            // LOGIN_OIDC doesn't throw when the subscription isn't Active -
            // it just doesn't persist a session. Only proceed to "home" when
            // one was actually established; router.beforeEach would bounce
            // an unauthenticated push back to "login" anyway, but going
            // there directly keeps the redirect from flashing "home" first.
            const isLoggedIn = this.$store.getters["AUTH/IS_LOGGED_IN"];
            this.$router.push(isLoggedIn ? "home" : "login");
          })
          .catch(err => {
            console.warn("login error", err);
          });
      },
      immediate: true,
    },
  },
  components: { Loading },
};
</script>
